import { render, staticRenderFns } from "./ImageGalleryItem.vue?vue&type=template&id=2ff13968&scoped=true&"
import script from "./ImageGalleryItem.vue?vue&type=script&lang=ts&"
export * from "./ImageGalleryItem.vue?vue&type=script&lang=ts&"
import style0 from "./ImageGalleryItem.vue?vue&type=style&index=0&id=2ff13968&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff13968",
  null
  
)

export default component.exports